import { t } from '../../common/translations';
import { format } from '../../common/dates';
import formatCurrency from '../../common/formatCurrency';

const needsBreakDown = ({ breakdown, prorated }, index) => {
  return index === 0 ||
        (!!breakdown.deposit_amount) ||
        (!!breakdown.cleaning_fee) ||
        prorated !== undefined;
};

const printDay = (date, index) => {
  if (index === 0) {
    return t('scheduled_payments.js.modal.today');
  }
  return format(date, 'MMMM DD, YYYY');
};

const printCurrency = (amount) => {
  return `R$ ${formatCurrency(amount)}`;
};

const printRentLabel = (index) => {
  if (index === 0) {
    return t('scheduled_payments.js.modal.first_month_rent');
  }

  return t('scheduled_payments.js.modal.month_rent');
};

export const content = (payments) => `
<main>
  <p class="scheduled-payments-modal__description">
    ${t('scheduled_payments.js.modal.description')}
  </p>

  ${payments.map((p, i) => `
    <div>
      <div class="d-flex flex-row justify-content-between fs-6 fw-bold text-uppercase pb-1 border-bottom border-tabas-grey">
          <div class="letter-space-1d5">${printDay(p.date, i)}</div>
          <div class="letter-space-1">${printCurrency(p.total)}</div>
      </div>
      ${needsBreakDown(p, i) ? (`
        <div class="my-4 letter-space-1 fw-light text-tabas-grey">
          ${p.prorated ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.prorated')}</div>
          </div>`) : ''}
          ${p.breakdown.rent ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${printRentLabel(i)}</div>
            <div>${p.breakdown.only_rent ? printCurrency(p.breakdown.only_rent) : printCurrency(p.breakdown.rent)}</div>
          </div>`) : ''}
          ${p.breakdown.coupon_discount ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div class="text-success fw-bold">${t('scheduled_payments.js.modal.discount_coupon')}</div>
            <div class="text-success fw-bold">${printCurrency(p.breakdown.coupon_discount)}</div>
          </div>`) : ''}
          ${p.breakdown.long_term_discount < 0 ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.long_term_discount')}</div>
            <div>-R$ ${formatCurrency(-1 * p.breakdown.long_term_discount)}</div>
          </div>`) : ''}
          ${p.breakdown.cleaning_fee ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.cleaning_fee')}</div>
            <div>${printCurrency(p.breakdown.cleaning_fee)}</div>
          </div>`) : ''}
          ${p.breakdown.deposit_amount ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.deposit_amount')}</div>
            <div>${printCurrency(p.breakdown.deposit_amount)}</div>
          </div>`) : ''}
          ${p.breakdown.final_cleaning_fee ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.final_cleaning_fee')}</div>
            <div>${printCurrency(p.breakdown.final_cleaning_fee)}</div>
          </div>`) : ''}
          ${p.breakdown.fire_insurance ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.fire_insurance')}</div>
            <div>${printCurrency(p.breakdown.fire_insurance)}</div>
          </div>`) : ''}
          ${p.breakdown.condominium_price ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.condominium')}</div>
            <div>${printCurrency(p.breakdown.condominium_price)}</div>
          </div>`) : ''}
          ${p.breakdown.iptu_price ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.iptu')}</div>
            <div>${printCurrency(p.breakdown.iptu_price)}</div>
          </div>`) : ''}
          ${p.breakdown.pet_fee ? (`
          <div class="d-flex flex-row justify-content-between my-1">
            <div>${t('scheduled_payments.js.modal.pet_fee')}</div>
            <div>${printCurrency(p.breakdown.pet_fee)}</div>
          </div>`) : ''}
        </div>
      `) : ''}
    </div>`).join('')}
</main>
`;
